module.exports = __webpack_public_path__ + "img/20180120_3.fac89bff.jpeg";